import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";


const AboutSection = () => {

  const [about, setAbout] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/about`)
      .then((res) => res.json())
      .then((info) => setAbout(info));
  }, []);

  return (
    <>
      {about.slice(0, 1).map((item) => (
        <section className="about-style-three pb_150 modern-home-section" id="about-sec" key={item._id}>
          <div className="auto-container">
            <div className="modern-about-shell">
              <div className="row align-items-center g-4">
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image_block_five">
                    <div className="image-box modern-about-image-wrap">
                      <figure className="image">
                        <img src={item.aboutImgOne} alt={item.aboutHeading} />
                      </figure>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content_block_four">
                    <div className="content-box modern-about-copy">
                      <div data-animation-box className="sec-title mb_25">
                        <span data-animation-text className="sub-title">{item.aboutText}</span>
                        <h2>{item.aboutHeading}</h2>
                      </div>
                      <div className="text-box mb_40">
                        <p>{item.aboutDetails}</p>
                      </div>

                      <div className="modern-about-points">
                        <div className="single-item modern-about-point">
                          <div className="icon-box"><i className="icon-13" /></div>
                          <div>
                            <h3>{item.pointOne}</h3>
                            <p>{item.pointOneText}</p>
                          </div>
                        </div>

                        <div className="single-item modern-about-point">
                          <div className="icon-box"><i className="icon-10" /></div>
                          <div>
                            <h3>{item.pointTwo}</h3>
                            <p>{item.pointTwoText}</p>
                          </div>
                        </div>
                      </div>

                      <div className="modern-about-actions">
                        <Link to="/contact-us" className="theme-btn btn-one">
                          Book a Free Demo
                        </Link>
                        <Link to="/service" className="modern-inline-link">
                          Explore services
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default AboutSection;
